import { addItemToCollection } from "directus/src/operations";

export async function createDraftTimesheetEntry({ item }) {
    try {
        const query = {
            fields: [
                "id",
                "date",
                "description",
                "employee.avatar",
                "employee.first_name",
                "employee.id",
                "employee.last_name",
                "logged_hours",
                "tag.id",
                "tag.label",
                "tag.color",
            ],
        };

        const data = await addItemToCollection("draft_timesheet", item, query);

        return data;
    } catch (error) {
        console.log(error);
        throw error;
    }
}
